export default __webpack_public_path__ + "static/media/page_of_wands.34fa27db.png";